import { SnapshotEntry } from 'helpers/api/rawVesta/getSnapshot';
import React, { useEffect, useState } from 'react';
import { AxisOptions, Chart } from 'react-charts';
import BigNumber from 'bignumber.js';

export const SnapshotChart = ({
  snapshotData
}: {
  snapshotData: SnapshotEntry[];
}) => {
  type SnapshotChartData = {
    epoch: number;
    amount: number;
  };

  type Series = {
    label: string;
    data: SnapshotChartData[];
  };
  const data: Series[] = [
    {
      label: 'vEGLD liquidity weight history',
      data: snapshotData.map((sd) => {
        return {
          epoch: sd.epoch,
          amount: new BigNumber(sd.snapshotInfo.weighted_amount)
            .dividedBy(new BigNumber(10).pow(18))
            .toNumber()
        };
      })
    }
  ];

  const primaryAxis = React.useMemo(
    (): AxisOptions<SnapshotChartData> => ({
      getValue: (datum) => datum.epoch
    }),
    []
  );

  const secondaryAxes = React.useMemo(
    (): AxisOptions<SnapshotChartData>[] => [
      {
        getValue: (datum) => datum.amount
      }
    ],
    []
  );
  console.log('chart data', data);
  return data === undefined ? (
    <h2>Data is undefined</h2>
  ) : (
    <Chart
      datatype='linear'
      options={{
        data: data,
        primaryAxis: primaryAxis,
        secondaryAxes: secondaryAxes
      }}
    />
  );
};
